import PlanSelection from "./components/PlanSelection";

export function BusinessStepFive(props: React.ComponentProps<typeof PlanSelection>) {
  const handleSelect = (planCode: string) => {
    localStorage.setItem('selectedPlan', planCode);
  };

  return <PlanSelection {...props} onSelect={handleSelect} />;
}